module.exports = __webpack_public_path__ + "fonts/GothamPro-Medium.020e7c28.woff2";